<!--充值记录 rechargeRecord-->
<template>
  <div class="myoperateRecord" style="padding: 10px;">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small mr-20">
              <span>业主名称：</span>
              <el-input v-model="ownerName" type="text" class="numberInput" autocomplete="off" placeholder="请输入名称"
                clearable></el-input>
            </div>
            <div class="  mr-20">
              <span>方式：</span>
              <el-select v-model="noticeType" placeholder="请选择" style="width: 100px;">
                <el-option label="全部" value=" "> </el-option>
                <el-option label="充值" value="1"> </el-option>
                <el-option label="退费" value="2"> </el-option>
              </el-select>
            </div>
            <div class="input-small ">
              <span>日期：</span>
              <el-date-picker v-model="dataTime" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <el-button type="primary" plain @click="pageIndex=1;search()" class="search-btn">查询</el-button>
            <el-button type="primary" size="mini" @click="exportList">导出</el-button>

          </div>
        </el-scrollbar>
      </div>

      <div class="mytable" :style="{'height':heights+'px'}">
        <el-table :data="dataList" :height="heights - 20" border style="width: 100%;" stripe>
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" width="50" label="序号" align="center" />
          <el-table-column prop="项目名称" label="项目名称" />
          <el-table-column prop="业主名称" label="业主名称" />
          <el-table-column prop="方式" label="方式" />
          <el-table-column prop="时间" label="时间" />
          <el-table-column prop="金额" label="金额" />

        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange"
          @handleSizeChange="handleSizeChange" />
      </div>
      <RefundDialog ref="refundDialog"></RefundDialog>
      <downloadTable ref="downloadTable"></downloadTable>
    </div>
  </div>
</template>

<script>
  import datePicker from '@/components/module/universal/datePicker.vue'
  import singleSelection from '@/components/module/selection/singleSelection.vue'
  import infoListMultipleSelection from './infoListMultipleSelection.vue'
  import RefundDialog from './dialogs/RefundDialog.vue'
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      datePicker,
      singleSelection,
      infoListMultipleSelection,
      RefundDialog,
      elPagination,
      downloadTable
    },
    props: {},
    data () {
      return {
        heights: document.getElementById('app').clientHeight-240,
        dataList: [{"项目名称": "商场","时间": "2024-05-12 13:09:19","业主名称": "麦当劳","方式": "微信充值","金额": "1000.00"},{"项目名称": "商场","时间": "2024-05-12 12:53:48","业主名称": "蜜雪冰城","方式": "微信充值","金额": "500.00"},{"项目名称": "商场","时间": "2024-05-11 21:31:54","业主名称": "九木杂物社","方式": "微信充值","金额": "500.00"},{"项目名称": "商场","时间": "2024-05-11 21:31:38","业主名称": "九木杂物社","方式": "微信充值","金额": "500.00"},{"项目名称": "商场","时间": "2024-05-11 15:58:01","业主名称": "RDD","方式": "微信充值","金额": "500.00"},{"项目名称": "商场","时间": "2024-05-11 11:20:52","业主名称": "太阪町餐车","方式": "微信充值","金额": "2000.00"},{"项目名称": "商场","时间": "2024-05-11 11:19:27","业主名称": "咪味的茶","方式": "微信充值","金额": "1000.00"},{"项目名称": "商场","时间": "2024-05-10 18:54:28","业主名称": "olas","方式": "微信充值","金额": "5000.00"},{"项目名称": "商场","时间": "2024-05-10 18:54:09","业主名称": "olas","方式": "微信充值","金额": "5000.00"},{"项目名称": "商场","时间": "2024-05-10 14:47:19","业主名称": "老饕小馆","方式": "微信充值","金额": "4000.00"},{"项目名称": "商场","时间": "2024-05-09 21:03:02","业主名称": "回力","方式": "微信充值","金额": "500.00"},{"项目名称": "商场","时间": "2024-05-09 19:51:38","业主名称": "回力","方式": "微信充值","金额": "500.00"},{"项目名称": "商场","时间": "2024-05-09 19:29:56","业主名称": "东邪","方式": "微信充值","金额": "3000.00"},{"项目名称": "商场","时间": "2024-05-09 11:46:16","业主名称": "喜市多","方式": "现金充值","金额": "10000.00"},{"项目名称": "商场","时间": "2024-05-09 11:44:15","业主名称": "MARC JACOBS","方式": "现金充值","金额": "2000.00"},{"项目名称": "商场","时间": "2024-05-09 10:16:57","业主名称": "麦当劳","方式": "微信充值","金额": "1000.00"},{"项目名称": "商场","时间": "2024-05-08 17:30:16","业主名称": "太平洋咖啡","方式": "现金充值","金额": "5000.00"},{"项目名称": "商场","时间": "2024-05-07 10:40:28","业主名称": "多乐之日","方式": "现金充值","金额": "6000.00"},{"项目名称": "商场","时间": "2024-05-07 10:28:59","业主名称": "麦当劳","方式": "微信充值","金额": "1000.00"},{"项目名称": "商场","时间": "2024-05-07 10:12:02","业主名称": "蜜雪冰城","方式": "微信充值","金额": "500.00"}],
        pageIndex: 1,
        pageSize: 20,
        total: 0,
        dataTime: '',
        ownerName: '',
        filterTime: false,
        searchChange: false,
        noticeClass: 0,
        noticeType: '',
        loading: false,//加载 
      }
    },

    mounted () {
      this.search()
    },

    computed: {
      nowUser () {
        return this.$store.userStore.state.nowUserInfo
      },
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      nowSelectDate () {
        return this.$store.cacheStore.getters.getNowSelectDate
      },
      nowTimeInterval () {
        return this.$store.cacheStore.getters.getOperateRecordsTimeInterval
      },
    },
    watch: {
      nowUnit () {
        this.search()
      },
    },
    methods: {
      downloadFile (data,fileName,type) {
        const blob=new Blob([data],{type});
        const url=URL.createObjectURL(blob);
        const link=document.createElement('a');
        link.href=url;
        link.download=fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      //下载表格excel
      exportList () {
        var beginTime=''
        var endTime=''
        if(!isempty(this.dataTime)) {
          let dataTime=new Date(this.dataTime[0]).format('yyyy-MM-dd')
          let dataTime2=new Date(this.dataTime[1]).format('yyyy-MM-dd')
          beginTime=new Date(dataTime+' 00:00:00').getTime()
          endTime=new Date(dataTime2+' 23:59:59').getTime()
        }
        var params={
          unitId: this.nowUnit.id,
          beginTime,
          endTime,
          fileName: '充值记录',
          ownerName: this.ownerName,
          detailType: this.noticeType,
        };
        var a=localStorage.getItem('baseURL');//获取网址
        var b=a||DWSystemSetting.baseURL;//判断使用备用网址
        var url=b+'/revenueManagement/exportMoneyRecordAllBill'
        for(var key in params) {
          if(url.indexOf('?')===-1) {
            url+='?'
            url+=(key+'='+params[key])
          } else {
            if(params[key]) {
              url+=('&'+key+'='+params[key])
            }

          }
        }
        window.open(url,"_blank");
        return
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();
        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,[],year+"-"+month+"-"+day+'-操作记录','.mytable')
      },
      search () {
        // console.log("搜索");
        var beginTime=''
        var endTime=''
        if(!isempty(this.dataTime)) {
          let dataTime=new Date(this.dataTime[0]).format('yyyy-MM-dd')
          let dataTime2=new Date(this.dataTime[1]).format('yyyy-MM-dd')
          beginTime=new Date(dataTime+' 00:00:00').getTime()
          endTime=new Date(dataTime2+' 23:59:59').getTime()
        }
        var params={
          beginTime,
          endTime,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          unitId: this.nowUnit.id,
          ownerName: this.ownerName,
          detailType: this.noticeType,
        }
        this.loading=true
        request({url: "/revenueManagement/getMoneyRecordAllBill",method: "get",params}).then(res => {
          this.loading=false
          if(res.code==200) {
            this.dataList=res.data.dataList;
            this.total=res.data.total;
          }
        })
        // 


        // this.$api.noticeApi.getUnitNoticeLimit(this.nowUnit.id,this.pageIndex,this.pageSize,this.noticeClass,this.noticeType,beginTime,endTime,this.ownerName,respon => {
        //   this.loading=false
        //   this.dataList=respon.dataList
        //   this.total=respon.total
        // },err => {
        //   this.$message.error(err);

        // })
      },
      backout (item) {
        this.$refs.refundDialog.open(result => {
          this.$api.meterReadingApi.refund(item.id,result.fee,result.password,respon => {
            this.$message({
              message: respon,
              type: 'success'
            })
            this.search()
          },err => {
            this.$message.error(err);
          })
        })
      },
      // 批量导出
      exportReport () {
        var beginTime=this.filterTime? this.nowTimeInterval.startDate.getTime():undefined
        var endTime=this.filterTime? this.nowTimeInterval.endDate.getTime():undefined
        var title=this.nowUnit.name+'操作记录信息'
        this.$store.cacheStore.state.load=true
        this.$api.noticeApi.exportUnitNotice(this.nowUnit.id,this.noticeClass,this.noticeType,beginTime,endTime,this.ownerName,respon => {
          saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
          this.$store.cacheStore.state.load=false
        },err => {
          this.$store.cacheStore.state.load=false
          this.$dialogMethod.showMessage(err)
        })
      },

      dataTimeFormatter (row,column) {
        //格式化日期
        return new Date(row.createTime).format("yyyy-MM-dd hh:mm:ss")
      },
      //当前页
      pageindexChange (val) {
        this.pageIndex=val;
        this.search()
      },
      //页大小
      handleSizeChange (val) {
        this.pageSize=val;
        this.pageIndex=1;
        this.search()
      },

    }
  }
</script>

<style scoped lang="scss">
  .myoperateRecord {
    .con {
      width: 100%;
      height: 100%;
      padding: 12px 20px;
      background-color: #fff;
      box-sizing: border-box;

    }

    .search-input-btn {
      margin-top: 0px;
    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }
  }
</style>